<template>

  <b-col class="col-sm-12"
         :class="{['col-md-'+checkColumns()]:!onlySearch || bigSearch,'col-md-6':(onlySearch && !bigSearch) || checkColumns() === 6}">

    <div>

      <b-form-checkbox class="mb-1" v-model="innerValue"
                       v-if="field.type===InputType.type.INPUT && field.var === VarType.type.BOOLEAN" switch>
        {{ field.name }}
        <t-help
            v-show="field.help.length > 0"
            :title="field.help"/>
      </b-form-checkbox>

      <!--Input númerico-->
      <t-input
          v-else-if="field.type===InputType.type.INPUT && (field.var === VarType.type.INTEGER || field.var === VarType.type.DOUBLE)"
          v-model="innerValue"
          number
          not-autocomplete
          :form-command="command"
          :form-status="status"
          :help="field.help"
          :small="field.note"
          :label="field.name"
          :decimals="field.decimalPrecision"
          :accept-zero="field.acceptZero"
          :class="{'text-danger':nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined}"
          :class-input="nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined ? 'text-danger': ''"
          :add-error="nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined ? nonConformance.alertError : ''"
          :fixed="checkIsFixed()"
          :required="checkIsRequired()"
          @keyup.enter.native="onPressEnter"
      />
      <!--SOMENTE TEXTO NUMERICO POR ENQUANTO PODERÁ ENVIAR O ENTER, POIS OUTROS CAMPOS PODEM GERAR CONFLITO COMO O CAMPO DATA-->

      <!--Input texto com máscaras-->
      <!--todo deixar todos os tipos de mascaras dinamicos-->
      <t-input
          v-else-if="field.type===InputType.type.INPUT && (field.var === VarType.type.STRING || field.var === VarType.type.DATE)"
          v-model="innerValue"
          not-autocomplete
          :form-command="command"
          :form-status="status"
          :small="field.note"
          :help="field.help"
          :label="field.name"
          :date="field.var === VarType.type.DATE"
          :time="field.mask === 'time'"
          :cep="field.mask === 'zipcode'"
          :cnpj="field.mask === 'br_cnpj'"
          :cpf="field.mask === 'br_cpf'"
          :email="field.mask === 'email'"
          :email-multiple="field.mask === 'email_multiple'"
          :color-reduced="field.mask === 'color'"
          :upper="field.mask === 'upper'"
          :lower-reduced="field.mask === 'lower'"
          :class="{'text-danger':nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined}"
          :class-input="nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined ? 'text-danger': ''"
          :add-error="nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined ? nonConformance.alertError : ''"
          :fixed="checkIsFixed()"
          :required="checkIsRequired()"
      />

      <!-- radio ou select-->
      <t-input
          v-else-if="field.type===InputType.type.SELECT || field.type===InputType.type.SELECT_COLOR || field.type===InputType.type.RADIO"
          v-model="innerValue"
          :form-command="command"
          :form-status="status"
          :small="field.note"
          :help="field.help"
          :label="field.name"
          :options="field.options"
          :select="field.type === InputType.type.SELECT || field.type === InputType.type.SELECT_COLOR"
          :radio="field.type === InputType.type.RADIO"
          :select-colors="field.type === InputType.type.SELECT_COLOR"
          :class="{'text-danger':nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined}"
          :class-input="nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined ? 'text-danger': ''"
          :add-error="nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined ? nonConformance.alertError : ''"
          :fixed="checkIsFixed()"
          :required="checkIsRequired()"
      />

      <t-input
          v-else-if="field.type===InputType.type.TEXTAREA"
          v-model="innerValue"
          textarea
          max-length="1000"
          :form-command="command"
          :form-status="status"
          :small="field.note"
          :help="field.help"
          :label="field.name"
          :class="{'text-danger':nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined}"
          :class-input="nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined ? 'text-danger': ''"
          :add-error="nonConformance!==null && nonConformance!==undefined && nonConformance.alertError !== undefined ? nonConformance.alertError : ''"
          :fixed="checkIsFixed()"
          :required="checkIsRequired()"
      />

      <div v-else-if="field.type===InputType.type.LABEL">
        <b-card-title class="border-bottom mt-2 mb-2 pb-2 pt-2">{{ field.name }}
          <t-help v-if="field.help !== undefined && field.help !== null && field.help !== ''" :title="field.help"/>
        </b-card-title>

      </div>


    </div>

  </b-col>

</template>
<script>
import VarType from "@/model/types/resource/VarType";
import InputType from "@/model/types/resource/InputType";

export default {
  name: 't-field-customized',
  props: {
    value: {
      type: null,
      default: null
    },
    field: {
      type: Object
    },
    command: String,
    status: String,
    onlySearch: {
      type: Boolean,
      default: false,
    },
    bigSearch: Boolean,
    nonConformance: Object,
  },
  data() {
    return {
      VarType,
      InputType,
      innerValue: "", //Não poderá ser nulo, pois caso contrário não trará as informações de alteração
    }
  },
  mounted() {

    if (this.field.type === InputType.type.TEXTAREA && this.value === null) {
      this.innerValue = ''
    } else {
      this.innerValue = this.value
    }


  },
  methods: {

    onPressEnter() {

      //Envia informando que o enter foi pressinado
      this.$emit("onPressEnter")

    },

    checkColumns() {

      if (this.onlySearch && !this.bigSearch) {

        if (this.field.columns < 6) {
          //Menor que metade do layout, será sempre 6
          return 12
        } else {
          return this.field.columns
        }
      } else {
        return this.field.columns
      }
    },

    checkIsFixed() {
      return this.field.fixed && !this.onlySearch
    },

    checkIsRequired() {
      return this.field.required && !this.onlySearch
    }

  },
  watch: {
    value(v) {
      this.innerValue = v
    },
    innerValue(v) {

      this.field.value = v
      this.$emit("input", v)
    }
  }
}
</script>
<style>

</style>
